import { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { renewTokenUser } from "./redux/features/auth/authSlice";
import { useDispatch } from "react-redux";
// import { useServiceWorker } from "./useServiceWorker";
// import cookie from "js-cookie";
// =========================== Pages =========================== //

// 1. 404 Pages
import NotFound from "./pages/NotFound";

// 2. Account Access Blocked Error
import FreezeAccount from "./pages/FreezeAccount.jsx";

// 2b. Halaman publik tanpa login (dibuka lewat QR di lembar faktur)
import InvoiceVerificationPage from "./pages/purchasePbf/InvoiceVerificationPage.jsx";

// 3. Login, Register & Forgot Password
import EmailLogin from "./components/screen/login/EmailLogin";
import ForgotPassword from "./components/screen/forgotPassword/ForgotPassword";
import ForgotPasswordLogin from "./components/screen/forgotPassword/ForgotPasswordLogin";
import CreateNewPassword from "./components/screen/forgotPassword/CreateNewPassword";
import ForgotPasswordContext from "./components/context/ForgotPasswordProvider";
import RegisterMpi from "./components/screen/login/RegisterMpi.jsx";
import RegisterPharmacy from "./components/screen/login/RegisterPharmacy/RegisterPharmacy.jsx";

// 4. Dashboard
import Dashboard from "./pages/dashboard/Dashboard";
import HistoryTransactionDashboardPage from "./pages/dashboard/HistoryTransactionDashboardPage";
import InvoiceTransactionPage from "./pages/dashboard/InvoiceTransactionPage";
import DetailPaymentDashboardPage from "./pages/dashboard/DetailPaymentDashboardPage";

// 5. Purchase
// 5A. Online Purchase
// import PurchaseComplaintPage from "./pages/purchase/PurchaseComplaintPage.jsx";
// 5A. Online Purchase - Pbf
import PurchasePbfPage from "./pages/purchasePbf/PurchasePbfPage.jsx";
import PurchaseProductListPbfPage from "./pages/purchasePbf/PurchaseProductListPbfPage.jsx";
import PurchasePrincipalPbfPage from "./pages/purchasePbf/PurchasePrincipalPbfPage.jsx";
import PurchaseProductDetailPbfPage from "./pages/purchasePbf/PurchaseProductDetailPbfPage.jsx";
import PurchaseCheckoutPbfPage from "./pages/purchasePbf/PurchaseCheckoutPbfPage.jsx";
import PurchaseCartPbfPage from "./pages/purchasePbf/PurchaseCartPbfPage.jsx";
import PurchaseListTransactionPbfPage from "./pages/purchasePbf/PurchaseListTransactionPbfPage.jsx";
import PurchaseCheckoutVerifiedPbfPage from "./pages/purchasePbf/PurchaseCheckoutVerifiedPbfPage.jsx";
import ActivateOlinAmanahPage from "./pages/purchase/ActivateOlinAmanahPage.jsx";
import ActivateOlinAmanahConfirmPage from "./pages/purchase/ActivateOlinAmanahConfirmPage.jsx";
import PurchaseCheckoutSuccessPbfPage from "./pages/purchasePbf/PurchaseCheckoutSuccessPbfPage.jsx";
import PurchaseDetailTransactionPbfPage from "./pages/purchasePbf/PurchaseDetailTransactionPbfPage.jsx";
// 5A. Old Purchase Page -- Redacted
// import SelectedProductProvider from "./components/context/SelectedProductProvider";
// import VoucherProductProvider from "./components/context/VoucherProductProvider";
// import Purchase from "./pages/purchase_old/Purchase.jsx";
// import CategoryPage from "./pages/purchase_old/CategoryPage.jsx";
// import PrincipalPage from "./pages/purchase_old/PrincipalPage.jsx";
// import SelectedPrincipalPage from "./pages/purchase_old/SelectedPrincipalPage.jsx";
// import SelectedCategoryPage from "./pages/purchase_old/SelectedCategoryPage.jsx";
// import DetailPurchaseProductPage from "./pages/purchase_old/DetailProductPurchasePage.jsx";
// import CartDetailsPage from "./pages/purchase_old/CartDetailsPage.jsx";
// import CheckoutPurchasePage from "./pages/purchase_old/CheckoutPurchasePage.jsx";
// import PurchasePaymentPage from "./pages/purchase_old/PurchasePaymentPage.jsx";
// import ListTransactionPurchasePage from "./pages/purchase_old/ListTransactionPurchasePage.jsx";
// import WaitingPaymentPurchasePage from "./pages/purchase_old/WaitingPaymentPurchasePage.jsx";
// import DetailTransactionPage from "./pages/purchase_old/DetailTransactionPage.jsx";
// import InvoiceTransactionPurchasePage from "./pages/purchase_old/InvoiceTransactionPurchasePage.jsx";
import ApprovalPbfPage from "./pages/purchasePbf/ApprovalPbfPage.jsx";
import DetailApprovalPbfPage from "./pages/purchasePbf/DetailApprovalPbfPage.jsx";
// 5B. OLISA Approval
import SfaApprovalPage from "./pages/sfa/SfaApprovalPage.jsx";
import SfaDetailPage from "./pages/sfa/SfaDetailPage.jsx";

// 6. Order Management System
import OrderManagementSystemPage from "./pages/oms/OrderManagementSystemPage.jsx";
import OrderManagementSystemSettingsPage from "./pages/oms/OrderManagementSystemSettingsPage.jsx";
// 6A. Order Pages -- Redacted
// import ChatPage from "./pages/Chat/Chat";
// import ChatboxProvider from "./components/context/ChatboxProvider";
// import OrderPage from "./pages/Order/OrderPage";
// import OrderDetailPage from "./pages/Order/OrderDetailPage";

// 7. Defecta
import DefectaPage from "./pages/defecta/DefectaPage.jsx";
import DefectaArchivePage from "./pages/defecta/DefectaArchivePage.jsx";

// 8. Purchase Order
import PurchaseOrder from "./pages/purchaseOrder/PurchaseOrder";
import ImportPurchaseOrderPage from "./pages/purchaseOrder/ImportPurchaseOrderPage";
import CreatePurchaseOrder from "./pages/purchaseOrder/CreatePurchaseOrder";
import DetailPurchaseOrderPage from "./pages/purchaseOrder/DetailPurchaseOrder";
// import DetailInvoicePurchaseOrder from "./pages/purchaseOrder/DetailInvoicePurchaseOrder.jsx";

// 9. Billing
// 9A. Online Billing
import OnlineBillingPage from "./pages/billing/OnlineBillingPage.jsx";
import OnlineBillingDetailPage from "./pages/billing/OnlineBillingDetailPage.jsx";
// 9B. Manual Billing
import BillingManualListPage from "./pages/billingManual/BillingManualListPage.jsx";
import CreateBillingManualPage from "./pages/billingManual/CreateBillingManualPage.jsx";
import BillingManualDetailPOPage from "./pages/billingManual/BillingManualDetailPOPage.jsx";
import BillingManualDetailPage from "./pages/billingManual/BillingManualDetailPage.jsx";
import EditBillingManualDraftPage from "./pages/billingManual/EditBillingManualDraftPage.jsx";
import BillingManualEditPage from "./pages/billingManual/BillingManualEditPage.jsx";

// 10. Inventory
// Providers
import ProductActiveProvider from "../src/components/context/ProductActiveProvider";
import ProductHabisProvider from "./components/context/ProductHabisProvider";
import ProductExpiredProvider from "./components/context/ProductExpiredProvider";
import VerificationMethodProvider from "./components/context/VerificationMethodProvider";
import PaymentStatusProvider from "./components/context/PaymentStatusProvider";
// 10A. Inventory List
import InventoryPage from "./pages/inventory/Inventory/InventoryPage.jsx";
// import ProductActivePage from "./pages/inventory/produkAktif/ProductActivePage";
// import ProductHabisPage from "./pages/inventory/produkHabis/ProductHabisPage";
// import ProductHoldPage from "./pages/inventory/produkHold/ProductHoldPage";
// import ProductExpiredPage from "./pages/inventory/produkExpired/ProductExpiredPage";
// import ProductInactivePage from "./pages/inventory/produkInactive/ProductInactivePage";
import EditDetailProductInactive from "./components/screen/inventory/productInactive/EditDetailProductInactive";
import EditDetailsProductActive from "./pages/inventory/produkAktif/EditDetailsProductActive";
import EditDetailProductStockOut from "./components/screen/inventory/productHabis/EditDetailProductStockOut";
import EditDetailProductHold from "./components/screen/inventory/productHold/EditDetailProductHold";
import EditDetailProductHoldPage from "./pages/inventory/produkHold/EditDetailProductHoldPage";
import EditDetailsProductHabisPage from "./pages/inventory/produkHabis/EditDetailsProductHabisPage.jsx";
import DetailsProductActive from "./pages/inventory/produkAktif/DetailsProductActive";
import DetailsProductExpiredPage from "./pages/inventory/produkExpired/DetailsProductExpiredPage";
import DetailsProductHabisPage from "./pages/inventory/produkHabis/DetailsProductHabisPage";
import DetailsProductHoldPage from "./pages/inventory/produkHold/DetailsProductHoldPage";
import DetailsProductInactivePage from "./pages/inventory/produkInactive/DetailsProductInactivePage";
import UpdateStockActive from "./pages/inventory/produkAktif/UpdateStockActive";
import AddProductActive from "./pages/inventory/produkAktif/AddProductActive";
import ImportActiveProduct from "./pages/inventory/produkAktif/ImportActiveProduct";
import ExportProductPage from "./pages/inventory/produkAktif/ExportProductPage";
import PrintCreatePurchasePage from "./pages/inventory/produkHabis/PrintCreatePurchase";
import PrintReturPage from "./pages/inventory/produkExpired/PrintReturPage";
import UpdateSeveralStockActive from "./pages/inventory/produkAktif/UpdateSeveralStockActive";
import CreatePurchasePage from "./pages/inventory/produkHabis/CreatePurchasePage";
import ReturPage from "./pages/inventory/produkExpired/ReturPage";
import UpdateProductHabis from "./pages/inventory/produkHabis/UpdateProductHabis";
// 10B. Penyesuaian Stock
import StockAdjustmentPage from "./pages/inventory/StockAdjustment/StockAdjustmentPage";
import CreateStockAdjustmentPage from "./pages/inventory/StockAdjustment/CreateAdjustmentStock";
// 10C. Stock Opname
import StockOpnamePage from "./pages/inventory/StockOpname/StockOpnamePage";
import StockOpnameRecapPage from "./pages/inventory/StockOpname/StockOpnameRecapPage";
import CreateStockOpnamePage from "./pages/inventory/StockOpname/CreateStockOpnamePage";
// 10D. Kartu Stok
import CardStockNewPage from "./pages/inventory/CardStock/CardStockNewPage";
import CardStockDetailNewPage from "./pages/inventory/CardStock/CardStockDetailNewPage";
import CardStockDetailBatchPage from "./pages/inventory/CardStock/CardStockDetailBatchPage.jsx";
// 10E. Inventory Summary
import InventorySummaryPage from "./pages/inventory/InventorySummary/InventorySummaryPage";
import InventorySummaryDetailPage from "./pages/inventory/InventorySummary/InventorySummaryDetailPage";
// 10F. Sinkronisasi Akun
import SyncGoodDoctorPage from "./pages/sinkronisasi/SyncGoodDoctorPage.jsx";
import SyncMedisendPage from "./pages/sinkronisasi/SyncMedisendPage.jsx";

// 11. Patient Care
// 11A. RME
import MedicalRecordListPage from "./pages/patientCare/medicalRecord/MedicalRecordListPage.jsx";
import DetailMedicalRecordPage from "./pages/patientCare/medicalRecord/DetailMedicalRecordPage.jsx";
// 11B. Patient Database
import PatientCarePatientDatabasePage from "./pages/patientCare/PatientCarePatientDatabasePage.jsx";
// 11C. Doctor Database
import PatientCareDoctorDatabasePage from "./pages/patientCare/PatientCareDoctorDatabasePage.jsx";
// 11D. Initial Analysis
import InitialAnalysisListPage from "./pages/patientCare/initialAnalysis/InitialAnalysisListPage.jsx";
import AddInitialAnalysisListPage from "./pages/patientCare/initialAnalysis/AddInitialAnalysisListPage.jsx";
// 11E. Doctor Analysis
import DoctorAnalysisListPage from "./pages/patientCare/doctorAnalysis/DoctorAnalysisListPage.jsx";
import AddDoctorAnalysisPage from "./pages/patientCare/doctorAnalysis/AddDoctorAnalysisPage.jsx";
// 11F. Services
import PatientCareServicesPage from "./pages/patientCare/PatientCareServicesPage";
// 11G. Prescription History
import PrescriptionHistoryListPage from "./pages/patientCare/prescriptonHistory/PrescriptionHistoryListPage.jsx";
import DetailPrescriptionPage from "./pages/patientCare/prescriptonHistory/DetailPrescriptionPage.jsx";
import MakeCopyPrescriptionPage from "./pages/patientCare/prescriptonHistory/MakeCopyPrescriptionPage.jsx";

// 12. Central Warehouse
// 12A. Central Warehouse Defecta (same as 7. Defecta)
// 12B. Central Warehouse Purchase Order (same as 8. Purchase Order)
// 12C. Central Warehouse Billing (same as 9B. Manual Billing)
// 12D. Central Warehouse Inventory (same as 10. Inventory)
// // 12D.A. Central Warehouse Inventory List (same as 10A. Inventory List)
// // 12D.B. Central Warehouse Kartu Stok (same as 10B. Penyesuaian Stock)
// // 12D.C. Central Warehouse Inventory Summary (same as 10E. Inventory Summary)
// // 12D.D. Central Warehouse Penyesuaian Stock (same as 10B. Penyesuaian Stock)
// // 12D.E. Central Warehouse Stock Opname (same as 10C. Stock Opname)
// 12E. Central Warehouse Invoice
// // 12E.A. Central Warehouse Invoice (same as 16A. Customer)
// // 12E.B. Invoice Invoice (same as 16B. Invoice List)
// // 12E.C. Invoice Setting Promo (same as 16C. Setting Promo)
// // 12E.D. Invoice Setting Invoice (same as 16D. Setting Invoice)
// 12F. Central Warehouse Alokasi
import AllocationListPage from "./pages/centralWarehouse/allocation/AllocationListPage.jsx";
import AddAllocationPage from "./pages/centralWarehouse/allocation/AddAllocationPage.jsx";
import DetailAllocationPage from "./pages/centralWarehouse/allocation/DetailAllocationPage.jsx";
// 12G. Central Warehouse Transfer
import TransferListPage from "./pages/centralWarehouse/transfer/TransferListPage.jsx";
import AddTransferPage from "./pages/centralWarehouse/transfer/AddTransferPage.jsx";
import DetailTransferPage from "./pages/centralWarehouse/transfer/DetailTransferPage.jsx";
// 12H. Central Warehouse Retur to Warehouse
import ReturnWarehouseListPage from "./pages/centralWarehouse/returnWarehouse/ReturnWarehouseListPage.jsx";
import AddReturnWarehousePage from "./pages/centralWarehouse/returnWarehouse/AddReturnWarehousePage.jsx";
import DetailReturnWarehousePage from "./pages/centralWarehouse/returnWarehouse/DetailReturnWarehousePage.jsx";
// 12I. Central Warehouse Inbox Warehouse & Outlet
import InboxWarehousePage from "./pages/centralWarehouse/inbox/InboxWarehousePage.jsx";
import DetailInboxWarehousePage from "./pages/centralWarehouse/inbox/DetailInboxWarehousePage.jsx";
// 12J. Central Warehouse Request Allocation
import RequestAllocationListPage from "./pages/centralWarehouse/request/RequestAllocationListPage.jsx";
import AddRequestAllocationPage from "./pages/centralWarehouse/request/AddRequestAllocationPage.jsx";
import DetailRequestAllocationPage from "./pages/centralWarehouse/request/DetailRequestAllocationPage.jsx";
// 12K. Central Warehouse Request Transfer
import RequestTransferListPage from "./pages/centralWarehouse/request/RequestTransferListPage.jsx";
import AddRequestTransferPage from "./pages/centralWarehouse/request/AddRequestTransferPage.jsx";
import DetailRequestTransferPage from "./pages/centralWarehouse/request/DetailRequestTransferPage.jsx";

// 13. Consignment
import ConsignmentPage from "./pages/inventory/Consignment/ConsignmentPage";
import AddNewConsignmentPage from "./pages/inventory/Consignment/AddNewConsignmentPage";
import DetailConsignmentPage from "./pages/inventory/Consignment/DetailConsignmentPage";
import DetailConsignmentProductPage from "./pages/inventory/Consignment/DetailConsignmentProductPage";
import EditConsignmentProductPage from "./pages/inventory/Consignment/EditConsignmentProductPage";
import EditPriceonsignmentProductPage from "./pages/inventory/Consignment/EditPriceConsignmentProductPage";

// 14. Retur
import ReturProductPage from "./pages/retur/ReturProductPage.jsx";
import CreateReturProductPage from "./pages/retur/CreateReturProductPage.jsx";
import ReturDetailProductPage from "./pages/retur/ReturDetailProductPage.jsx";
import ReturSellPage from "./pages/retur/ReturSellPage.jsx";
import CreateReturSellPage from "./pages/retur/CreateReturSellPage.jsx";
import ReturDetailSellPage from "./pages/retur/ReturDetailSellPage.jsx";
import ReturSellPOSPage from "./pages/retur/ReturSellPOSPage.jsx";
import ReturDetailSellPOSPage from "./pages/retur/ReturDetailSellPOSPage.jsx";
import CreateReturSellPOSPage from "./pages/retur/CreateReturSellPOSPage.jsx";

// 15. Reporting
import Reporting from "./pages/reporting/Reporting";
import LogShiftPage from "./pages/reporting/LogShift/LogShiftPage";
import DetailLogShiftPage from "./pages/reporting/LogShift/DetailLogShiftPage";
import DetailInvoiceReportSalesPage from "./pages/reporting/DetailInvoiceReportSalesPage";
import ReportingProfitnLossPage from "./pages/reporting/ReportingProfitnLoss/ReportingProfitnLossPage";
import ReportingProductPage from "./pages/reporting/LogShift/ProductReportingPage";
import OperationalCostPage from "./pages/reporting/OperationalCost/OperationalCostPage";
import CreateOperationalCostPage from "./pages/reporting/OperationalCost/CreateOperationalCostPage";

// 16. Invoice
// 16A. Customer
import CustomerInvoicePage from "./pages/invoice/CustomerInvoicePage";
import CreateCustomerInvoicePage from "./pages/invoice/CreateCustomerInvoicePage";
import DetailCustomerInvoicePage from "./pages/invoice/DetailCustomerInvoicePage";
// 16B. Invoice List
import InvoicePage from "./pages/invoice/InvoicePage";
import CreateInvoicePage from "./pages/invoice/CreateInvoicePage";
import DetailInvoicePage from "./pages/invoice/DetailInvoicePage";
// 16C. Setting Promo
import SettingPromoPage from "./pages/invoice/SettingPromoPage";
import CreatePromoInvoicePage from "./pages/invoice/CreatePromoInvoicePage";
// 16D. Setting Invoice
import SettingInvoicePage from "./pages/invoice/SettingInvoicePage";

// 17. Discount
import Discount from "./pages/discount/Discount";
import AddDiscount from "./pages/discount/AddDiscount";
import DetailDiscount from "./pages/discount/DetailDiscount";

// 18. Pelanggan
import Customer from "./pages/customer/Customer";
import DetailCustomer from "./pages/customer/DetailCustomer";
import DetailOrder from "./components/screen/customer/DetailOrder";

// 19. Sales
import Sales from "./pages/sales/Sales.jsx";
import DetailSales from "./pages/sales/DetailSales.jsx";

// 20. User Management
import UserManagement from "./pages/userManagement/UserManagement";
import TambahPengguna from "./pages/userManagement/TambahPengguna";
import DetailUserPage from "./pages/userManagement/DetailUserPage";

// 21. Settings
import PaymentMethod from "./pages/settings/PaymentMethod";
import InvoiceSetting from "./pages/settings/InvoiceSetting";
import PSEFSetting from "./pages/settings/PSEFSetting";

// 22. Profile
import AccountProfilePage from "./pages/profile/AccountProfilePage";
import AccountProfileDetailPage from "./pages/profile/AccountProfileDetailPage";
import RequestPasswordChangePage from "./pages/profile/passwordChange/RequestPasswordChangePage";
import RequestEmailChangePage from "./pages/profile/EmailChange/RequestEmailChangePage";
import RequestPhoneChange from "./components/screen/profile/PhoneChange/RequestPhoneChange";
import VerificationMethodPage from "./pages/profile/VerificationMethodPage";
import PaymentSuccess from "./components/screen/profile/PaymentSuccess";
// import DetailUser from "./components/screen/userManagement/DetailUser";
import SubscriptionPage from "./pages/profile/SubscriptionPage";
import CheckoutSubscriptionPage from "./pages/profile/CheckoutSubscriptionPage";
import SubscriptionPurchasePage from "./pages/profile/SubscriptionPurchasePage";
import InvoiceSubscriptionPage from "./pages/profile/InvoiceSubscriptionPage";
import SuccessPage from "./components/screen/profile/SuccessPage";

const App = () => {
  // const { waitingWorker, showReload, reloadPage } = useServiceWorker();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  /**
   * DISABLED SERVICE WORKER ON 5/11/2024
   *
   * REASON:
   * 1. OLIN's PWA doesn't need to be available offline based on discussion
   * 2. The service worker fetches every 1s to check for updates which creates an
   * uneccessary big load on server
   *
   * To prevent service worker errors
   * the service worker is unregistered upon encounter on first render
   * */
  // useEffect(() => {
  //   if (showReload && waitingWorker) {
  //     navigator.serviceWorker.getRegistration().then((reg) => {
  //       if (reg) reg.unregister();
  //     });
  //   }
  // }, [waitingWorker, showReload]);

  // DEPRECATED FUNCTION: Reload page when new service worker is available
  // useEffect(() => {
  //   if (showReload && waitingWorker) {
  //     alert("A new version of this app is available. Please reload to update.");

  //     const registration = navigator.serviceWorker.getRegistration();
  //     console.log(registration);
  //     if (registration) {
  //       registration.unregister();
  //       window.location.reload(); // hard reload
  //     }
  //   }
  // }, [waitingWorker, showReload]);

  //Renew Token
  setInterval(() => {
    dispatch(renewTokenUser());
  }, 600000);

  useEffect(() => {
    // const statusUser = localStorage.getItem("status_code_user");
    const statusCompany = localStorage.getItem("status_code");

    // if (
    //   (!statusUser || !statusCompany) &&
    //   ![
    //     "/",
    //     "/login",
    //     "/register/mpi",
    //     "/forgot-password",
    //     "/forgot-password/new-password",
    //     "/forgot-password/login",
    //   ].includes(pathname)
    // ) {
    //   dispatch(logout());
    //   navigate("/");
    // }

    if (
      statusCompany &&
      ((Number(statusCompany) === 2 &&
        !["/login", "/profile", "/subscription", "/invoice-verification"].some(
          (link) => pathname.includes(link),
        )) ||
        (Number(statusCompany) === 3 &&
          ![
            "/home",
            "/login",
            "/profile",
            "/subscription",
            "/purchase",
            "/approval-pbf",
            "/sfa",
            "/online-billing",
            "/invoice-verification",
          ].some((link) => pathname.includes(link))))
    )
      navigate(`/no-access`);

    if (
      pathname === `/no-access` &&
      Number(statusCompany) !== 3 &&
      Number(statusCompany) !== 2
    )
      navigate(`/profile`);
  }, [pathname]);

  return (
    <div>
      <Routes>
        {/* 1. 404 Pages*/}
        <Route path="*" element={<NotFound />} />
        {/* 2. Account Access Blocked Error */}
        <Route path="/no-access" element={<FreezeAccount />} />
        {/* 2b. Verifikasi dokumen faktur — publik, tanpa HOC */}
        <Route
          path="/invoice-verification/:invoiceUid"
          element={<InvoiceVerificationPage />}
        />
        {/* 3. Login, Register & Forgot Password */}
        <Route path="/login" element={<EmailLogin />} />
        <Route path="/register/mpi" element={<RegisterMpi />} />
        <Route path="/register/new-pharmacy" element={<RegisterPharmacy />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/forgot-password"
          element={
            <ForgotPasswordContext>
              <ForgotPassword />
            </ForgotPasswordContext>
          }
        />
        <Route
          path="/forgot-password/new-password"
          element={
            <ForgotPasswordContext>
              <CreateNewPassword />
            </ForgotPasswordContext>
          }
        />
        {/* 4. Dashboard */}
        <Route path="/home" element={<Dashboard />} />
        <Route
          path="/history-dashboard"
          element={<HistoryTransactionDashboardPage />}
        />
        <Route
          path="/invoice-transaction/:id"
          element={<InvoiceTransactionPage />}
        />
        <Route
          path="/detail-transaction"
          element={<DetailPaymentDashboardPage />}
        />
        {/* 5. Purchase */}
        {/* 5A. Online Purchase (MPI) — no longer used, every old link lands on PBF */}
        <Route
          path="/purchase/*"
          element={<Navigate to="/purchase-pbf" replace />}
        />
        {/* Still used by the PBF checkout's Olin Amanah payment option */}
        <Route
          path="/purchase/activate-amanah"
          element={<ActivateOlinAmanahPage />}
        />
        <Route
          path="/purchase/confirm-amanah"
          element={<ActivateOlinAmanahConfirmPage />}
        />
        {/* 5A. Online Purchase - Pbf */}
        <Route path="/purchase-pbf" element={<PurchasePbfPage />} />
        <Route
          path="/purchase-pbf/product-list/:listType/:principalId?"
          element={<PurchaseProductListPbfPage />}
        />
        <Route
          path="/purchase-pbf/banner/:bannerId"
          element={<PurchaseProductListPbfPage isBanner={true} />}
        />
        <Route
          path="/purchase-pbf/principal"
          element={<PurchasePrincipalPbfPage />}
        />
        <Route
          path="/purchase-pbf/detail-product/:id/:type"
          element={<PurchaseProductDetailPbfPage />}
        />
        <Route path="/purchase-pbf/cart" element={<PurchaseCartPbfPage />} />
        <Route
          path="/purchase-pbf/checkout"
          element={<PurchaseCheckoutPbfPage />}
        />
        <Route
          path="/purchase-pbf/list-transaction/:statusId?"
          element={<PurchaseListTransactionPbfPage />}
        />
        <Route
          path="/purchase-pbf/detail-transaction/:invoiceUid"
          element={<PurchaseDetailTransactionPbfPage />}
        />
        <Route
          path="/purchase-pbf/confirm-checkout/:invoiceNum"
          element={<PurchaseCheckoutVerifiedPbfPage />}
        />
        <Route
          path="/purchase-pbf/checkout-result/:invoiceNum"
          element={<PurchaseCheckoutSuccessPbfPage />}
        />
        {/* Old CBD success link, kept for bookmarks and open tabs. */}
        <Route
          path="/purchase-pbf/success-payment/:invoiceNum"
          element={<PurchaseCheckoutSuccessPbfPage />}
        />
        <Route path="/approval-pbf" element={<ApprovalPbfPage />} />
        <Route
          path="/approval-pbf/detail/:id"
          element={<DetailApprovalPbfPage />}
        />
        {/* note: checkout still in progress */}
        {/* 5B. OLISA Approval */}
        <Route path="/sfa" element={<SfaApprovalPage />} />
        <Route path="/sfa/detail/:id" element={<SfaDetailPage />} />
        {/* 6. Order Management System */}
        <Route
          path="/oms/:filter?/:orderId?"
          element={<OrderManagementSystemPage />}
        />
        <Route
          path="/oms/settings"
          element={<OrderManagementSystemSettingsPage />}
        />
        {/* 
            6A. Order Pages
            NOTE: 
            Disabled due to psef & oms role being the same
            Users who have access to oms now will be redirected to 404 when accessing order pages
        */}
        {/* <Route
          path="/orders"
          element={
            <ChatboxProvider>
              <OrderPage />
            </ChatboxProvider>
          }
        />
        <Route path="/order/:invoiceNumber" element={<OrderDetailPage />} />
        <Route path="/chat" element={<ChatPage />} />
         */}
        {/* 7. Defecta */}
        <Route path="/defecta" element={<DefectaPage />} />
        <Route path="/defecta/archive" element={<DefectaArchivePage />} />
        {/* 8. Purchase Order */}
        <Route path="/purchase-order/" element={<PurchaseOrder />} />
        <Route
          path="/purchase-order/import"
          element={<ImportPurchaseOrderPage />}
        />
        <Route
          path="/purchase-order/create-po/:label?"
          element={<CreatePurchaseOrder />}
        />
        <Route
          path="/purchase-order/detail-po/:param"
          element={<DetailPurchaseOrderPage />}
        />
        <Route
          path="/purchase-order/detail-invoice/:id/:billId"
          element={<BillingManualDetailPage />}
        />
        <Route
          path="/purchase-order/edit/:param"
          element={<CreatePurchaseOrder isEdit={true} />}
        />
        {/* 9. Billing */}
        {/* 9A. Online Billing */}
        {/* Old online billing — no longer used; its ids do not match PBF billing, so every old link lands on the PBF list */}
        <Route
          path="/online-billing/*"
          element={<Navigate to="/online-billing-pbf" replace />}
        />
        <Route
          path="/online-billing-pbf/:pageSetting?"
          element={<OnlineBillingPage isPbf={true} />}
        />
        <Route
          path="/online-billing-pbf/detail/:invNum"
          element={<OnlineBillingDetailPage isPbf={true} />}
        />
        {/* 9B. Manual Billing */}
        <Route
          path="/manual-billing/:pageSetting?"
          element={<BillingManualListPage />}
        />
        <Route
          path="/manual-billing/po-list"
          element={<CreateBillingManualPage />}
        />
        <Route
          path="/manual-billing/create-billing/:id/:flag"
          element={<BillingManualDetailPOPage />}
        />
        <Route
          path="/manual-billing/detail/:id/:billId"
          element={<BillingManualDetailPage />}
        />
        <Route
          path="/manual-billing/edit-draft/:id/:flag"
          element={<EditBillingManualDraftPage />}
        />
        <Route
          path="/manual-billing/edit-billing/:id/:billId"
          element={<BillingManualEditPage />}
        />
        {/* 10. Inventory */}
        {/* 10A. Inventory List */}
        <Route path="/inventory/:status?" element={<InventoryPage />} />
        {/* <Route path="/inventory/produk-aktif" element={<ProductActivePage />} />
        <Route path="/inventory/produk-habis" element={<ProductHabisPage />} />
        <Route path="/inventory/produk-hold" element={<ProductHoldPage />} />
        <Route
          path="/inventory/produk-expired"
          element={<ProductExpiredPage />}
        />
        <Route
          path="/inventory/produk-inactive"
          element={<ProductInactivePage />}
        /> */}
        <Route
          path="/inventory/produk-aktif/detail-product/:id"
          element={<DetailsProductActive />}
        />
        <Route
          path="/inventory/produk-expired/detail-product/:id"
          element={<DetailsProductExpiredPage />}
        />
        <Route
          path="/inventory/produk-inactive/detail-product/:id"
          element={<DetailsProductInactivePage />}
        />
        <Route
          path="/inventory/produk-habis/detail-product/:id"
          element={<DetailsProductHabisPage />}
        />
        <Route
          path="/inventory/produk-habis/edit-product-details/:id"
          element={<EditDetailsProductHabisPage />}
        />
        <Route
          path="/inventory/produk-hold/detail-product/:id"
          element={<DetailsProductHoldPage />}
        />
        <Route
          path="/inventory/produk-aktif/edit-product-details/:id"
          element={<EditDetailsProductActive />}
        />
        <Route
          path="/inventory/produk-inactive/edit-product-details/:id"
          element={<EditDetailProductInactive />}
        />
        <Route
          path="/inventory/produk-habis/edit-product-details/:id"
          element={<EditDetailProductStockOut />}
        />
        <Route
          path="/inventory/produk-hold/edit-product-details/:id"
          element={<EditDetailProductHoldPage />}
        />
        <Route
          path="/inventory/update-stock"
          element={
            <ProductActiveProvider>
              <UpdateStockActive />
            </ProductActiveProvider>
          }
        />
        <Route
          path="/inventory/update-stock-habis"
          element={
            <ProductActiveProvider>
              <UpdateProductHabis />
            </ProductActiveProvider>
          }
        />
        <Route path="/inventory/tambah-produk" element={<AddProductActive />} />
        <Route
          path="/inventory/update-stock-several"
          element={<UpdateSeveralStockActive />}
        />
        <Route path="/inventory/export" element={<ExportProductPage />} />
        <Route path="/inventory/import" element={<ImportActiveProduct />} />
        <Route
          path="/inventory/create-purchase"
          element={
            <ProductHabisProvider>
              <CreatePurchasePage />
            </ProductHabisProvider>
          }
        />
        <Route
          path="/inventory/retur"
          element={
            <ProductExpiredProvider>
              <ReturPage />
            </ProductExpiredProvider>
          }
        />
        <Route
          path="/inventory/print-SP"
          element={
            <ProductHabisProvider>
              <PrintCreatePurchasePage />
            </ProductHabisProvider>
          }
        />
        <Route
          path="/inventory/print-retur"
          element={
            <ProductExpiredProvider>
              <PrintReturPage />
            </ProductExpiredProvider>
          }
        />
        {/* 10B. Penyesuaian Stock */}
        <Route
          path="/inventory/stock-adjustment"
          element={<StockAdjustmentPage />}
        />
        <Route
          path="/inventory/stock-adjustment/create-adjustment"
          element={<CreateStockAdjustmentPage />}
        />
        {/* 10C. Stock Opname */}
        <Route path="/inventory/stock-opname" element={<StockOpnamePage />} />
        <Route
          path="/inventory/stock-opname/stock-opname-recap/:psId"
          element={<StockOpnameRecapPage />}
        />
        <Route
          path="/inventory/stock-opname/create/:psId"
          element={<CreateStockOpnamePage />}
        />
        {/* 10D. Kartu Stok */}
        <Route path="/inventory/card-stock" element={<CardStockNewPage />} />
        <Route
          path="/inventory/card-stock/card-stock-detail-new/:productId"
          element={<CardStockDetailNewPage />}
        />
        <Route
          path="/inventory/card-stock/card-stock-detail-batch/:productId/:batchId"
          element={<CardStockDetailBatchPage />}
        />
        {/* 10E. Inventory Summary */}
        <Route
          path="/inventory/summary/:pageSetting?"
          element={<InventorySummaryPage />}
        />
        <Route
          path="/inventory/summary/:productId/:companyId"
          element={<InventorySummaryDetailPage />}
        />
        {/* 10F. Sinkronisasi Akun */}
        <Route
          path="/sinkronisasi/good-doctor"
          element={<SyncGoodDoctorPage />}
        />
        <Route path="/sinkronisasi/medisend" element={<SyncMedisendPage />} />
        {/* 11. Patient Care */}
        {/* 11A. RME */}
        <Route
          path="/patient-care/medical-record"
          element={<MedicalRecordListPage />}
        />
        <Route
          path="/patient-care/medical-record/detail/:id"
          element={<DetailMedicalRecordPage />}
        />
        {/* 11B. Patient Database */}
        <Route
          path="/patient-care/patient-database"
          element={<PatientCarePatientDatabasePage />}
        />
        {/* 11C. Doctor Database */}
        <Route
          path="/patient-care/doctor-database"
          element={<PatientCareDoctorDatabasePage />}
        />
        {/* 11D. Initial Analysis */}
        <Route
          path="/patient-care/initial-analysis"
          element={<InitialAnalysisListPage />}
        />
        <Route
          path="/patient-care/initial-analysis/create-analysis"
          element={<AddInitialAnalysisListPage />}
        />
        <Route
          path="/patient-care/initial-analysis/edit-analysis/:id"
          element={<AddInitialAnalysisListPage />}
        />
        <Route
          path="/patient-care/initial-analysis/detail-analysis/:id"
          element={<AddInitialAnalysisListPage isDetail={true} />}
        />
        {/* 11E. Doctor Analysis */}
        <Route
          path="/patient-care/doctor-analysis"
          element={<DoctorAnalysisListPage />}
        />
        <Route
          path="/patient-care/doctor-analysis/create-analysis"
          element={<AddDoctorAnalysisPage />}
        />
        <Route
          path="/patient-care/doctor-analysis/edit-analysis/:id"
          element={<AddDoctorAnalysisPage />}
        />
        <Route
          path="/patient-care/doctor-analysis/detail-analysis/:id"
          element={<AddDoctorAnalysisPage isDetail={true} />}
        />
        {/* 11F. Services */}
        <Route
          path="/patient-care/services"
          element={<PatientCareServicesPage />}
        />
        {/* 11G. Prescription History */}
        <Route
          path="/patient-care/prescription-history"
          element={<PrescriptionHistoryListPage />}
        />
        <Route
          path="/patient-care/prescription-history/detail/:id"
          element={<DetailPrescriptionPage />}
        />
        <Route
          path="/patient-care/prescription-history/make-copy/:id"
          element={<MakeCopyPrescriptionPage />}
        />
        {/* 12. Central Warehouse */}
        {/* 12A. Central Warehouse Defecta */}
        <Route
          path="/central-warehouse/defecta"
          element={<DefectaPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/defecta/archive"
          element={<DefectaArchivePage isWarehouse={true} />}
        />
        {/* 12B. Central Warehouse Purchase Order */}
        <Route
          path="/central-warehouse/purchase-order/"
          element={<PurchaseOrder isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/purchase-order/create-po/:label?"
          element={<CreatePurchaseOrder isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/purchase-order/detail-po/:param"
          element={<DetailPurchaseOrderPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/purchase-order/detail-invoice/:id/:billId"
          element={<BillingManualDetailPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/purchase-order/edit/:param"
          element={<CreatePurchaseOrder isEdit={true} isWarehouse={true} />}
        />
        {/* 12C. Central Warehouse Billing */}
        <Route
          path="/central-warehouse/manual-billing/:pageSetting?"
          element={<BillingManualListPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/manual-billing/po-list"
          element={<CreateBillingManualPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/manual-billing/create-billing/:id/:flag"
          element={<BillingManualDetailPOPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/manual-billing/detail/:id/:billId"
          element={<BillingManualDetailPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/manual-billing/edit-draft/:id/:flag"
          element={<EditBillingManualDraftPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/manual-billing/edit-billing/:id/:billId"
          element={<BillingManualEditPage isWarehouse={true} />}
        />
        {/* 12D. Central Warehouse Inventory */}
        {/* 12D.A. Central Warehouse Inventory List */}
        <Route
          path="/central-warehouse/inventory/:status?"
          element={<InventoryPage isWarehouse={true} />}
        />
        {/* <Route
          path="/central-warehouse/inventory/produk-aktif"
          element={<ProductActivePage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-habis"
          element={<ProductHabisPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-hold"
          element={<ProductHoldPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-expired"
          element={<ProductExpiredPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-inactive"
          element={<ProductInactivePage isWarehouse={true} />}
        /> */}
        <Route
          path="/central-warehouse/inventory/produk-aktif/detail-product/:id"
          element={<DetailsProductActive isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-inactive/detail-product/:id"
          element={<DetailsProductInactivePage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-habis/detail-product/:id"
          element={<DetailsProductHabisPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-hold/detail-product/:id"
          element={<DetailsProductHoldPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-aktif/edit-product-details/:id"
          element={<EditDetailsProductActive isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-inactive/edit-product-details/:id"
          element={<EditDetailProductInactive isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-habis/edit-product-details/:id"
          element={<EditDetailProductStockOut isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/produk-hold/edit-product-details/:id"
          element={<EditDetailProductHoldPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/tambah-produk"
          element={<AddProductActive isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/export"
          element={<ExportProductPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/import"
          element={<ImportActiveProduct isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/retur"
          element={
            <ProductExpiredProvider>
              <ReturPage isWarehouse={true} />
            </ProductExpiredProvider>
          }
        />
        <Route
          path="/central-warehouse/inventory/update-stock"
          element={
            <ProductActiveProvider>
              <UpdateStockActive isWarehouse={true} />
            </ProductActiveProvider>
          }
        />
        <Route
          path="/central-warehouse/inventory/update-stock-habis"
          element={
            <ProductActiveProvider>
              <UpdateProductHabis isWarehouse={true} />
            </ProductActiveProvider>
          }
        />
        <Route
          path="/central-warehouse/inventory/update-stock-several"
          element={<UpdateSeveralStockActive isWarehouse={true} />}
        />
        {/* 12D.B. Central Warehouse Kartu Stok */}
        <Route
          path="/central-warehouse/inventory/card-stock"
          element={<CardStockNewPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/card-stock/card-stock-detail-new/:productId"
          element={<CardStockDetailNewPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/card-stock/card-stock-detail-batch/:productId/:batchId"
          element={<CardStockDetailBatchPage isWarehouse={true} />}
        />
        {/* 12D.C. Central Warehouse Inventory Summary */}
        <Route
          path="/central-warehouse/inventory/summary/:pageSetting?"
          element={<InventorySummaryPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/summary/:productId/:companyId/:pageSetting?"
          element={<InventorySummaryDetailPage isWarehouse={true} />}
        />
        {/* 12D.D. Central Warehouse Penyesuaian Stock */}
        <Route
          path="/central-warehouse/inventory/stock-adjustment"
          element={<StockAdjustmentPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/stock-adjustment/create-adjustment"
          element={<CreateStockAdjustmentPage isWarehouse={true} />}
        />
        {/* 12D.E. Central Warehouse Stock Opname */}
        <Route
          path="/central-warehouse/inventory/stock-opname"
          element={<StockOpnamePage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/stock-opname/stock-opname-recap/:psId"
          element={<StockOpnameRecapPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/inventory/stock-opname/create/:psId"
          element={<CreateStockOpnamePage isWarehouse={true} />}
        />
        {/* 12E. Central Warehouse Invoice */}
        {/* 12E.A. Invoice Customer */}
        <Route
          path="/central-warehouse/invoice/customer"
          element={<CustomerInvoicePage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/invoice/customer/detail-customer/:id"
          element={<DetailCustomerInvoicePage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/invoice/customer/create-customer"
          element={<CreateCustomerInvoicePage isWarehouse={true} />}
        />
        {/* 12E.B. Invoice Invoice */}
        <Route
          path="/central-warehouse/invoice/invoice"
          element={<InvoicePage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/invoice/invoice/create-invoice"
          element={<CreateInvoicePage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/invoice/invoice/detail-invoice/:invNum"
          element={<DetailInvoicePage isWarehouse={true} />}
        />
        {/* 12E.C. Invoice Setting Promo */}
        <Route
          path="/central-warehouse/invoice/promo"
          element={<SettingPromoPage isWarehouse={true} />}
        />
        <Route
          path="/central-warehouse/invoice/promo/create-promo"
          element={<CreatePromoInvoicePage isWarehouse={true} />}
        />
        {/* 12E.D. Invoice Setting Invoice */}
        <Route
          path="/central-warehouse/invoice/setting-invoice"
          element={<SettingInvoicePage isWarehouse={true} />}
        />
        {/* 12F. Central Warehouse Alokasi */}
        <Route
          path="/central-warehouse/allocation"
          element={<AllocationListPage />}
        />
        <Route
          path="/central-warehouse/allocation/create-allocation"
          element={<AddAllocationPage />}
        />
        <Route
          path="/central-warehouse/allocation/detail/:id"
          element={<DetailAllocationPage />}
        />
        {/* 12G. Central Warehouse Transfer */}
        <Route
          path="/central-warehouse/transfer"
          element={<TransferListPage />}
        />
        <Route
          path="/central-warehouse/transfer/create-transfer"
          element={<AddTransferPage />}
        />
        <Route
          path="/central-warehouse/transfer/detail/:id"
          element={<DetailTransferPage />}
        />
        {/* 12H. Central Warehouse Retur to Warehouse */}
        <Route
          path="/central-warehouse/retur-warehouse"
          element={<ReturnWarehouseListPage />}
        />
        <Route
          path="/central-warehouse/retur-warehouse/create-retur"
          element={<AddReturnWarehousePage />}
        />
        <Route
          path="/central-warehouse/retur-warehouse/detail/:id"
          element={<DetailReturnWarehousePage />}
        />
        {/* 12I. Central Warehouse Inbox Warehouse & Outlet */}
        <Route
          path="/central-warehouse/inbox/warehouse"
          element={<InboxWarehousePage type={1} />}
        />
        <Route
          path="/central-warehouse/inbox/outlet"
          element={<InboxWarehousePage type={2} />}
        />
        <Route
          path="/central-warehouse/inbox/warehouse/detail/:id"
          element={<DetailInboxWarehousePage type={1} />}
        />
        <Route
          path="/central-warehouse/inbox/outlet/detail/:id"
          element={<DetailInboxWarehousePage type={2} />}
        />
        {/* 12J. Central Warehouse Request Allocation */}
        <Route
          path="/central-warehouse/request-allocation"
          element={<RequestAllocationListPage />}
        />
        <Route
          path="/central-warehouse/request-allocation/create"
          element={<AddRequestAllocationPage />}
        />
        <Route
          path="/central-warehouse/request-allocation/detail/:id"
          element={<DetailRequestAllocationPage />}
        />
        {/* 12K. Central Warehouse Request Transfer */}
        <Route
          path="/central-warehouse/request-transfer"
          element={<RequestTransferListPage />}
        />
        <Route
          path="/central-warehouse/request-transfer/create"
          element={<AddRequestTransferPage />}
        />
        <Route
          path="/central-warehouse/request-transfer/detail/:id"
          element={<DetailRequestTransferPage />}
        />
        {/* 13. Consignment */}
        <Route path="/inventory/consignment" element={<ConsignmentPage />} />
        <Route
          path="/inventory/add-consignment"
          element={<AddNewConsignmentPage />}
        />
        <Route
          path="/inventory/consignment/:params"
          element={<DetailConsignmentPage />}
        />
        <Route
          path="/inventory/consignment/product/:params"
          element={<DetailConsignmentProductPage />}
        />
        <Route
          path="/inventory/consignment/edit-product-details/:params"
          element={<EditConsignmentProductPage />}
        />
        <Route
          path="/inventory/consignment/update-price/:params"
          element={<EditPriceonsignmentProductPage />}
        />
        {/* 14. Retur */}
        <Route path="/retur/buy-retur" element={<ReturProductPage />} />
        <Route
          path="/retur/buy-retur/create-retur"
          element={<CreateReturProductPage />}
        />
        <Route
          path="/retur/buy-retur/detail-retur/:id"
          element={<ReturDetailProductPage />}
        />
        <Route path="/retur/sell-retur/invoice" element={<ReturSellPage />} />
        <Route
          path="/retur/sell-retur/invoice/create-retur"
          element={<CreateReturSellPage />}
        />
        <Route
          path="/retur/sell-retur/invoice/detail-retur/:id"
          element={<ReturDetailSellPage />}
        />
        <Route
          path="/retur/sell-retur/pos/:pageSetting?"
          element={<ReturSellPOSPage />}
        />
        <Route
          path="/retur/sell-retur/pos/create-retur/:id"
          element={<CreateReturSellPOSPage />}
        />
        <Route
          path="/retur/sell-retur/pos/detail-retur/:id"
          element={<ReturDetailSellPOSPage />}
        />
        {/* 15. Reporting */}
        <Route path="/reporting/:pageSetting?" element={<Reporting />} />
        <Route path="/reporting/log-shift" element={<LogShiftPage />} />
        <Route path="/reporting/product" element={<ReportingProductPage />} />
        <Route
          path="/reporting/detail-log-shift"
          element={<DetailLogShiftPage />}
        />
        <Route
          path="/reporting/invoice"
          element={<DetailInvoiceReportSalesPage />}
        />
        <Route path="/operational/list" element={<OperationalCostPage />} />
        <Route
          path="/operational/create"
          element={<CreateOperationalCostPage />}
        />
        <Route
          path="/reporting/profit-loss"
          element={<ReportingProfitnLossPage />}
        />
        {/* 16. Invoice */}
        {/* 16A. Customer */}
        <Route path="/invoice/customer" element={<CustomerInvoicePage />} />
        <Route
          path="/invoice/customer/detail-customer/:id"
          element={<DetailCustomerInvoicePage />}
        />
        <Route
          path="/invoice/customer/create-customer"
          element={<CreateCustomerInvoicePage />}
        />
        {/* 16B. Invoice List */}
        <Route path="/invoice/invoice" element={<InvoicePage />} />
        <Route
          path="/invoice/invoice/create-invoice"
          element={<CreateInvoicePage />}
        />
        <Route
          path="/invoice/invoice/detail-invoice/:invNum"
          element={<DetailInvoicePage />}
        />
        {/* 16C. Setting Promo */}
        <Route path="/invoice/promo" element={<SettingPromoPage />} />
        <Route
          path="/invoice/promo/create-promo"
          element={<CreatePromoInvoicePage />}
        />
        {/* 16D. Setting Invoice */}
        <Route
          path="/invoice/setting-invoice"
          element={<SettingInvoicePage />}
        />

        {/* 17. Discount */}
        <Route path="/discount" element={<Discount />} />
        <Route path="/discount/add" element={<AddDiscount />} />
        {/* <Route path="/discount/detail/:id" element={<DetailDiscount isDetail={true}/>} /> */}
        <Route
          path="/discount/detail/:id"
          element={<AddDiscount isDetail={true} />}
        />

        {/* 18. Pelanggan */}
        <Route path="/pelanggan" element={<Customer />} />
        <Route
          path="/pelanggan/detail-pelanggan/:id"
          element={<DetailCustomer />}
        />
        <Route path="/pelanggan/detail-order/:id" element={<DetailOrder />} />

        {/* 19. Sales */}
        <Route path="/sales" element={<Sales />} />
        <Route path="/sales/detail-sales/:id" element={<DetailSales />} />

        {/* 20. User Management */}
        <Route path="/user-management" element={<UserManagement />} />
        <Route
          path="/user-management/create-user"
          element={<TambahPengguna />}
        />
        <Route
          path="/user-management/detail-user/:id/:companyId"
          element={<DetailUserPage />}
        />

        {/* 21. Settings */}
        <Route path="/settings/payment-method" element={<PaymentMethod />} />
        <Route path="/settings/invoice-setting" element={<InvoiceSetting />} />
        <Route path="/settings/psef-setting" element={<PSEFSetting />} />

        {/* 22. Profile */}
        <Route
          path="/profile"
          element={
            <VerificationMethodProvider>
              <AccountProfilePage />
            </VerificationMethodProvider>
          }
        />
        <Route
          path="/subscription"
          element={
            <PaymentStatusProvider>
              <SubscriptionPage />
            </PaymentStatusProvider>
          }
        />
        <Route
          path="/subscription/invoice/:billNumber/:invoiceType"
          element={
            <PaymentStatusProvider>
              <InvoiceSubscriptionPage />
            </PaymentStatusProvider>
          }
        />
        <Route
          path="/subscription/checkout/:id"
          element={<CheckoutSubscriptionPage />}
        />
        <Route
          path="/subscription/purchase"
          element={
            <PaymentStatusProvider>
              <SubscriptionPurchasePage />
            </PaymentStatusProvider>
          }
        />
        <Route
          path="/payment-status"
          element={
            <PaymentStatusProvider>
              <PaymentSuccess />
            </PaymentStatusProvider>
          }
        />
        <Route path="/profile/detail" element={<AccountProfileDetailPage />} />
        <Route
          path="/profile/request-password"
          element={<RequestPasswordChangePage />}
        />
        <Route path="/profile/request-phone" element={<RequestPhoneChange />} />
        <Route
          path="/profile/verification"
          element={
            <VerificationMethodProvider>
              <VerificationMethodPage />
            </VerificationMethodProvider>
          }
        />
        <Route
          path="/profile/request-email"
          element={<RequestEmailChangePage />}
        />
        <Route
          path="/success"
          element={
            <VerificationMethodProvider>
              <SuccessPage />
            </VerificationMethodProvider>
          }
        />

        {/* UNUSED PATHS (REVAMPED) */}
        {/* Not used anymore, all redirect to login */}
        {/* <Route
          path="/forgot-password/login"
          element={<ForgotPasswordLogin />}
        /> */}
        {/* 5A. Old Purchase Page */}
        {/* <Route
          path="/purchase/principals"
          element={
            <SelectedProductProvider>
              <PrincipalPage />
            </SelectedProductProvider>
          }
        />
        <Route
          path="/purchase/categories"
          element={
            <SelectedProductProvider>
              <CategoryPage />
            </SelectedProductProvider>
          }
        />
        <Route
          path="/purchase/principal-detail/:id"
          element={
            <SelectedProductProvider>
              <SelectedPrincipalPage />
            </SelectedProductProvider>
          }
        />
        <Route
          path="/purchase/category-detail/:id"
          element={
            <SelectedProductProvider>
              <SelectedCategoryPage />
            </SelectedProductProvider>
          }
        />
        <Route
          path="/purchase/detail/:id"
          element={<DetailPurchaseProductPage />}
        />
        <Route
          path="/purchase/cart-detail"
          element={
            <VoucherProductProvider>
              <CartDetailsPage />
            </VoucherProductProvider>
          }
        />
        <Route
          path="/purchase/checkout"
          element={
            <VoucherProductProvider>
              <CheckoutPurchasePage />
            </VoucherProductProvider>
          }
        />
        <Route
          path="/purchase/payment/:invoice"
          element={<PurchasePaymentPage />}
        />
        <Route
          path="/purchase/list-transaction-old"
          element={<ListTransactionPurchasePage />}
        />
        <Route
          path="/purchase/waiting-payment"
          element={<WaitingPaymentPurchasePage />}
        />
        <Route
          path="/purchase/detail-transaction/:invoice"
          element={<DetailTransactionPage />}
        />
        <Route
          path="/purchase/complain-old/:invoice"
          element={<ComplainPurchasePage />}
        />
        <Route
          path="/purchase/transaction-invoice/:invoice"
          element={<InvoiceTransactionPurchasePage />}
        /> */}
      </Routes>
    </div>
  );
};

export default App;
